import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nextI18NextConfig from '@/next-i18next.config.js';
import LanguageDetector from 'i18next-browser-languagedetector';

// Initialize i18next with React
i18n
  .use(initReactI18next)
  .use(LanguageDetector) // Add browser language detection
  .init({
    lng: nextI18NextConfig.i18n.defaultLocale,
    fallbackLng: nextI18NextConfig.fallbackLng,
    fallbackNS: nextI18NextConfig.fallbackNS,
    defaultNS: 'common',
    ns: ['common', 'header', 'footer', 'modals'],
    detection: nextI18NextConfig.detection,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false,
    },
    // Load resources from the public/locales directory
    // This will be supplemented by server-side translations
    // Resources are loaded separately by next-i18next on the server
  });

export default i18n;
